import { FEATURE_FLAGS } from '~/constants/featureFlags';
import { useUserSettings } from '~/hooks/useUserSettings';

export const useFeature = (flag: FEATURE_FLAGS) => {
  const { data, status } = useUserSettings();
  const enabledFeatures: FEATURE_FLAGS[] | string[] =
    data?.enabled_features ?? [];
  return {
    isEnabled: enabledFeatures?.includes(flag),
    status,
  };
};
